import { Popup, ICourse } from '../../../types/common';

const coursePopup = (course: ICourse): Popup => `
  <div class="covey-marker-popup covey-marker-popup--course">
    <div class="covey-marker-popup__header covey-marker-popup__header--course">
      <div class="covey-marker-popup__label covey-marker-popup__label--blue">title</div>
      <div class="covey-marker-popup__title">${course.name}</div>
    </div>
    <div class="covey-marker-popup__body">
      <div class="covey-marker-popup__content">
        <div class="covey-marker-popup__label">ACRES</div>
        <div class="covey-marker-popup__value">${course.acres}</div>
      </div>
    </div>
  </div>
`;

export default coursePopup;
